import { FC } from 'react';
import { Text, Tooltip } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { TreatyUserFragment } from '../../../graphql/generated';
import { formatTimestamp } from '../../../utils/date/date';

type LastLoginProps = {
  lastLogin: TreatyUserFragment['lastLogin'];
};

export const LastLogin: FC<LastLoginProps> = ({ lastLogin }) => {
  if (!lastLogin) return null;

  return (
    <Tooltip label={formatTimestamp(lastLogin)}>
      <Text>{dayjs(lastLogin).fromNow()}</Text>
    </Tooltip>
  );
};
